import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import AutomationPostModalAdditionalDetails from 'components/AutomationPostModalAdditionalDetails';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { TikTokUserAllowance } from 'containers/TikTokPostModal';
import UserAllowance from 'containers/TikTokPostModal/steps/UserAllowance';
import TikTokLegalText from 'containers/TikTokPostModal/TikTokLegalText';
import TikTokVisibilitySelector from 'containers/TikTokPostModal/TikTokVisibilitySelector';
import { TikTokPrivacyLevelOptionName } from 'redux/middleware/api/third-party-authentication-service/types';
import { tiktokIsPostingSelector } from 'redux/modules/social';
import { socialShareModalBlock as block } from '../../../../utils';
import { TIKTOK_MAX_DESCRIPTION_CHARS } from './constants';

export type TikTokPostComposerStepProps = {
  brandedContentSelected: boolean;
  privacyLevel: TikTokPrivacyLevelOptionName | undefined;
  userAllowance: TikTokUserAllowance[];
  onPrivacyLevelChange: (
    privacyLevel: TikTokPrivacyLevelOptionName | undefined,
  ) => void;
  onUserAllowanceChange: (userAllowance: TikTokUserAllowance[]) => void;
};

const TikTokPostComposerStep: React.FC<TikTokPostComposerStepProps> = ({
  brandedContentSelected,
  privacyLevel,
  userAllowance,
  onPrivacyLevelChange,
  onUserAllowanceChange,
}) => {
  const isPosting = useSelector(tiktokIsPostingSelector);

  const { description, setDescription, goToStep } = useSocialShareModal();

  return (
    <SocialShareModalBody loadingTitle="Tweeting Video" isLoading={isPosting}>
      <Spacer
        orientation="vertical"
        justify="center"
        align="start"
        space="20px"
        className={block('step-contents-container')}
      >
        <SocialShareModalAICaptionsField
          inputProps={{
            value: description,
            maxChars: TIKTOK_MAX_DESCRIPTION_CHARS,
            onChange: setDescription,
          }}
        />

        <TikTokVisibilitySelector
          brandedContentSelected={brandedContentSelected}
          value={privacyLevel}
          onChange={onPrivacyLevelChange}
        />

        <UserAllowance {...{ userAllowance, onUserAllowanceChange }} />

        <AutomationPostModalAdditionalDetails
          description="Disclose promotional goods or services in your videos."
          onClick={() => goToStep('disclosure')}
        />

        <TikTokLegalText brandedContentSelected={brandedContentSelected} />
      </Spacer>
    </SocialShareModalBody>
  );
};

export default TikTokPostComposerStep;
